export default __webpack_public_path__ + "static/media/list.d96d42ab.svg";